// styled
import styled from "styled-components";
import { About } from "../Styles";
//component
import Toggle from "./Toggle";
//framer-motion
import { AnimateSharedLayout, motion } from "framer-motion";
import {fade} from "../Animation"



export default function FaqSection() {
	return (
		<Faq>
			<h2>
				Any questions <span>FAQ</span>
			</h2>
			<AnimateSharedLayout>
			<Toggle title="How do I start?">
				{/* question-1 */}
				<div className="answer">
					<motion.p variants={fade}>Lorem ipsum dolor sit amet.</motion.p>
					<motion.p variants={fade}>
						Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolorum,
						ut.
					</motion.p>
				</div>
			</Toggle>
			<Toggle title="Daily schedule">
				{/* question-2 */}
				<div className="answer">
					<motion.p variants={fade}>Lorem ipsum dolor sit amet.</motion.p>
					<motion.p variants={fade}>
						Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolorum,
						ut.
					</motion.p>
				</div>
			</Toggle>
			<Toggle title="Different payment methods">
				{/* question-3 */}
				<div className="answer">
					<motion.p variants={fade}>Lorem ipsum dolor sit amet.</motion.p>
					<motion.p variants={fade}>
						Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolorum,
						ut.
					</motion.p>
				</div>
			</Toggle>
			<Toggle title="What services do we offer?">
				{/* question-4 */}
					<div className="answer">
						<motion.p variants={fade}>Lorem ipsum dolor sit amet.</motion.p>
						<motion.p variants={fade}>
							Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolorum,
							ut.
						</motion.p>
					</div>
			</Toggle>
			</AnimateSharedLayout>
		</Faq>
	);
}

const Faq = styled(About)`
	display: block;
	span {
		display: block;
	}
	h2 {
		padding-bottom: 2rem;
		font-weight: lighter;
	}
	.faq-line {
		background: #cccccc;
		height: 0.2rem;
		margin: 2rem 0rem;
		width: 100%;
	}
	.question {
		padding: 3rem 0rem;
		cursor: pointer;
	}
	.answer {
		padding: 2rem 0rem;
		p {
			padding: 1rem 0;
		}
	}
`;
